export enum InvoiceFactoringPath {
  batchId = "batchId",
  probillNumber = "probillNumber",
}

export type InvoiceFactoringPathParams = {
  [InvoiceFactoringPath.batchId]?: string;
  [InvoiceFactoringPath.probillNumber]?: string;
};
